import {
  EXPORT_REPORT_DESCRIPTIONS,
  EXPORT_REPORT_NAMES,
  ExportJobTypes,
} from 'constants/exportTypes';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Typography } from 'shared/mui/Typography';
import { formatRangeInputInTz } from 'utils/date';

type NotificationPopperListItemPrimaryTextProps = {
  exportType: ExportJobTypes;
  periodFrom: number;
  periodTo: number;
};

export const NotificationPopperListItemReportPrimary: React.FC<
  NotificationPopperListItemPrimaryTextProps
> = ({ exportType, periodFrom, periodTo }) => {
  const translate = useTypedTranslate();
  const descriptionKey = EXPORT_REPORT_DESCRIPTIONS[exportType];

  return (
    <>
      <Typography component="span">{translate(EXPORT_REPORT_NAMES[exportType])} </Typography>
      {periodFrom && periodTo && (
        <Typography component="span">
          {`${formatRangeInputInTz([periodFrom, periodTo], { format: 'dd.MM.yyyy' })}`}
        </Typography>
      )}
      {descriptionKey && (
        <Typography component="p" sx={{ marginTop: '8px' }}>
          {translate(descriptionKey)}
        </Typography>
      )}
    </>
  );
};
